<template>
  <div class="width-box w1000">
    <el-form class="pop-form-wrap" label-width="100px" :model="formData" ref="commonForm" v-if="formData">
      <el-form-item label="History (Years)" prop="CfYear">
        <el-input size="small" v-model.number="formData.CfYear"></el-input>
      </el-form-item>
      <el-form-item label="Annual output" prop="CfNum">
        <el-input size="small" v-model.number="formData.CfNum"></el-input>
      </el-form-item>
      <el-form-item label="Market share" prop="CfPer">
        <el-input size="small" v-model.number="formData.CfPer"></el-input>
      </el-form-item>
      <el-form-item label="Number of tray experiments" prop="CfTest">
        <el-input size="small" v-model.number="formData.CfTest"></el-input>
      </el-form-item>
      <el-form-item label="Global contact information" prop="CfGlobalInfo">
        <el-input size="small" v-model.number="formData.CfGlobalInfo" type="textarea" :autosize="true"></el-input>
      </el-form-item>
      <el-form-item label="Wechat QR Code" prop="CfWebQrcode">
        <img-upload v-model="formData.CfWebQrcode" size="small" tip="Image recommended size：140*140"></img-upload>
      </el-form-item>
      <el-form-item label="APP QR Code" prop="CfAppQrcode">
        <img-upload v-model="formData.CfAppQrcode" size="small" tip="Image recommended size：140*140"></img-upload>
      </el-form-item>
      <el-form-item label="Rolling Guaranteed" prop="CfYouzhiCover">
        <img-upload v-model="formData.CfYouzhiCover" size="small" tip="Image recommended size：140*140"></img-upload>
      </el-form-item>
      <el-form-item>
        <div class="pop-center-btn-wrap">
          <el-button type="primary" @click="doUpdate('commonForm')" v-if='formData.Id'>save</el-button>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import tools from '@/components/common/tools'
import imgUpload from '@/libcomponents/img-upload/img-upload'

// 数据对象
let dataStore = tools.createDataStore({
  CfYear: '',
  CfNum: '',
  CfPer: '',
  CfTest: '',
  CfGlobalInfo: '',
  CfWebQrcode: '',
  CfAppQrcode: ''
})

// 请求相关操作
let page = {
  methods: {
    // 修改操作
    updateDataAjax(id, state) {
      let data = tools.getModel(this.formData)
      tools.commonAjax.call(this, true, '/Ajax/UpdateConfigInAdmin', data).then(() => {
        this.$message.success('Operate success!')
        // 修改成功
        this.$emit('updateSuccess')
      })
    }
  }
}

export default {
  name: 'ConfigForm',
  componentName: 'ConfigForm',
  mixins: [page],
  components: {
    imgUpload
  },
  data() {
    return {
      formData: dataStore.getDefaultData()
    }
  },
  methods: {
    // 重置表单值
    resetValue() {
      this.formData = dataStore.getDefaultData()
    },
    // 设置表单值
    setValue(value) {
      this.formData = tools.extendData(dataStore.getDefaultData(), value || {})
    },
    // 修改
    doUpdate(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.updateDataAjax()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>




// WEBPACK FOOTER //
// ConfigForm.vue?1e3970dc